'use strict';

/* Controllers */

angular.module('myApp.controllers', []).
controller('rootCtrl', function($scope, profileOverviews, $rootScope,$location) {
    $rootScope.modalClose = false;

    //Locations
    $scope.counties = undefined;
    $scope.activeCounty = undefined;
    $scope.activeState = undefined;

    //Profiles
    $scope.profiles = undefined;
    $scope.activeProfile = undefined;

    //Profile to toggle and set active profile for identifying
    $scope.featureProfile = roadmapConfig.featureProfile;
    ROADMAP.profile.active(roadmapConfig.featureProfile);


    //Maps
    $scope.activeMap = undefined;
    $scope.basemapType = 'terrain';

    //Cart Items
    $scope.cart = [];

    //Loading status
    $scope.loadingCart = false;
    $scope.loadingPDF = false;
    $scope.loadingMap = false;



    $scope.$on('$locationChangeStart', function(event) {

        if($location.path() === '/map' && !$scope.activeProfile) $location.path('/select');
    });

    /********************** PROFILE STUFF **************************/
    //Profile page
    profileOverviews.async().then(function(d) {
        $scope.profileOverviews = d;
    });

    $scope.getOverview = function(profileName) {
        if ($scope.profileOverviews) {
            return $scope.profileOverviews[profileName];
        }
        return false;
    }


    //Get Counties
    ROADMAP.location.getLocations({
        'url': roadmapConfig.locationService,
        'layerId': 0,
        'label': 'Counties'
    }, function(counties, async) {
        $scope.counties = counties;
        //Need to use $apply bc async function threw us out of scope
        if (async) {
            $scope.$apply();
        }
    });
    //Get Profiles
    ROADMAP.service.init(roadmapConfig.dbUrl, roadmapConfig.mapBaseUrl, function(service, async) {
        //profiles
        //console.log(service)
        $scope.profiles = service.getProfiles();
        //service
        $scope.service = service;
        //hazard layers specific to this app
        var hazards = service.getMaps($scope.featureProfile);
        //Define all layers in an array
        $.each(hazards, function(name, hazardObj) {
            if (Object.prototype.toString.call(hazardObj.layers) !== '[object Array]') {
                hazardObj.layers = [hazardObj.layers];
            }
        });

        $scope.hazards = hazards;

        if (async) {
            $scope.$apply();
        }
    });
    //Set an active profile
    $scope.setActiveProfile = function(profileName) {
        $scope.activeProfile = profileName;
        //Set active map to first map in profile
        $scope.activeMap = ROADMAP.service.getMaps($scope.activeProfile, true)[0];
    };
    //Filter model for correct output
    $scope.sanitize = function(text) {
        //Use format for html replacement
        //\r\n = start of list
        //* List item
        var output = text.split("\r\n");
        var ul = 0;
        $.each(output, function(idx, str) {
            if (str[0] === "*") {
                str = "<li>" + str.replace('* ', '') + "</li>";
                if (ul % 2 == 0) {
                    str = "<ul>" + str;
                    ul++;
                }
            } else {
                str = "<p>" + str + "</p>";
                if (ul % 2 !== 0) {
                    str = "</ul>" + str;
                    ul++;
                }
            }
            output[idx] = str;
        })
        return output.join(' ');
    }

    //Removes underscores from key=>value for titles
    var _ = /_/g;
    $scope.keyToString = function(key) {
        if (key) {
            return key.replace(_, ' ');
        }
    }

    //Clear currently selected profile
    $scope.clearProfile = function() {
        ROADMAP.profile.clear();
        $scope.activeProfile = undefined;
    }

    //Clear currently selected county
    $scope.clearLocation = function() {
        ROADMAP.location.clear();        
        $scope.activeCounty = undefined;
        $scope.activeState = undefined;
    }

    $scope.testThis = function(){
        return activeProfile;
    }

}).
controller('navCtrl', function($scope, $location) {
    //Controller for main navbar
    $scope.nav = [{
        path: '/select',
        title: 'Select',
        tooltip: 'Select a flood hazard or community exposure',
        step: true
    }, {
        path: '/map',
        title: 'Map',
        tooltip: 'Create maps to share',
        step: true
    }, {
        path: '/collect',
        title: 'Collect',
        tooltip: 'Collect and share your maps',
        step: true
    }, {
        path: '/howto',
        title: 'Tips',
        tooltip: 'How to use maps with your community',
        step: false
    }, {
        path: '/resources',
        title: 'Resources',
        tooltip: 'View Resources',
        step: false
    }, {
        path: '/casestudies',
        title: 'Case Studies',
        tooltip: 'View Case Studies',
        step: false
    }, ];

    $scope.isNavVisible = function () {
       return $scope.$parent.activeProfile
    };

    $scope.isActive = function(nav) {
        if (nav.path == $location.path()) {
            return true;
        }
        return false;
    };
    $scope.isStep = function(nav) {
        if (nav.step == true) {
            return true;
        }
        return false;
    };

}).

controller('homeCtrl', function($scope) {
    //Controller for the home page
}).

controller('howtoCtrl', function($scope) {
    //Controller for the home page
}).

controller('configureCtrl', function($scope, profileOverviews, $rootScope) {

    $scope.closeModal = function() {
        $rootScope.modalClose = true;
    }

    /********************** LOCATION STUFF **************************/
    //Create Map
    ROADMAP.ol.createMap('location-select-map');
    //Add county layer and list
    ROADMAP.location.init({
        'url': roadmapConfig.locationService,
        'layerId': 0,
        'label': 'Counties',
        'opacity': 0.0
    });
    //Get Active County... this may be best stored in root ctrl
    if (ROADMAP.location.current()) {

        var selection = ROADMAP.location.current();        
        var tempObj = {name: selection.results[0].attributes.COUNTY_NAME, fips: selection.results[0].attributes.FIPSSTCO}
        
        $scope.$parent.activeState =  selection.results[0].attributes.STATE_NAME;
        $scope.$parent.activeCounty = tempObj;
    }
    //When a users mouse enters county list item
    $scope.highlightCounty = function(county) {
        //Add geometry to location and pan map
        if (!ROADMAP.location.current()) {
            ROADMAP.location.highlight(county.fips, 'polygon'); //Or point(default)
        }
    };
    //Set current active county
    $scope.setActiveCounty = function(county) {
        
        //Set Active
        //Zooom/Pan To County & Show 'Select Profile Link'
        ROADMAP.location.highlight(county.fips, 'polygon', true, function(r) {            
            $scope.$parent.activeCounty = r.results[0].attributes.COUNTY_NAME;
            $scope.$parent.activeState = r.results[0].attributes.STATE_NAME;
            $scope.$apply();
        });
    };

    $scope.setActiveState = function(state) {
        //Set the active state
        $scope.$parent.activeState = state;
    };

    $scope.isActiveState = function(state) {
        //show counties for the active state
        return state == $scope.$parent.activeState;
    }
    /********************** LOCATION STUFF **************************/

    /********************** PROFILE STUFF **************************/
    //Profile page
    /*  profileOverviews.async().then(function (d) {
      $scope.profileOverviews = d;
    });

    $scope.getOverview = function (profileName) {
      if($scope.profileOverviews) {
        return $scope.profileOverviews[profileName];
      }
      return false;
    }*/
    /********************** PROFILE STUFF **************************/
}).
controller('appCtrl', function($scope, $location, $rootScope, profileOverviews) {

        //SV: Check if user activated any hazards, and maintain state on controller reload
        var visibleHazardLayerOnLoad;
        if($scope.$parent.hazards)
            $.each($scope.$parent.hazards, function(name, hazard) {
               if(hazard.layers[0].visible){
                   visibleHazardLayerOnLoad = hazard.layers[0]
               }
            });

        //Remove old active layer
        ROADMAP.location.removeActiveLayer();
        //Activate Map
        ROADMAP.ol.createMap('appMap');
        checkAndSetBaseMap();
        ROADMAP.ol.resetMapLayers();
        //Register events
        ROADMAP.ol.registerIdentify();
        ROADMAP.ol.registerZoom();

        //Set initial no active layers
        $scope.activeFeature = [];
        //set scope class for hazard toggle
        $scope.noHazard = true;

        $scope.pickLocation = false;
        $scope.pickProfile = false;

        //hack to store state of base map.. code was initially designed
        //to completly refresh the map when ng-view map is loaded

        if($rootScope.basemapType) $scope.basemapType = $rootScope.basemapType;

        $scope.$watch('basemapType', function() {
            $rootScope.basemapType = $scope.basemapType;
            checkAndSetBaseMap();
        }, true);

        //SV: Check if user activated any hazards, and re-show the layer, time hack to
        //wait for map reload, as it was originally written to set all layers to false.
        //needs a re-write
        if(visibleHazardLayerOnLoad){
            window.setTimeout(function () {
                visibleHazardLayerOnLoad.visible = true;
                ROADMAP.ol.updateMapVisibilityOf(visibleHazardLayerOnLoad);
                visibleHazardLayerOnLoad.mapLayer.setVisibility(true);
            },200);
        }
  

        //Populate and Change State/Counties/Profile
        if ($scope.$parent.activeState) {
            $scope.stateCounties = $scope.counties[$scope.$parent.activeState];
            //$scope.stateCounties = $scope.stateCounties.sort();
        }
               
        $scope.showInfoModal = function ($event) {
            angular.element('.layer-info-dropdown').hide();
            angular.element($event.target).parent().find('.layer-info-dropdown').show();
        };

        $scope.hideInfoModal = function(){
            angular.element('.layer-info-dropdown').hide();
        }

        function checkAndSetBaseMap(){
            if ($scope.basemapType == 'terrain') {
                ROADMAP.ol.changeBaseLayer(0);
            } else {
                ROADMAP.ol.changeBaseLayer(1);
            }
        }
        //Create slider
        function createSlider(div, feature) {
            if (feature) {
                //Create Feature Layers Slider
                $scope.featureOpacity = ROADMAP.ol.getFeatureOpacity() * 100 || 100;
                setTimeout(function function_name (argument) {
                    $("#" + div).noUiSlider({
                        range: {
                                'min': [  0 ],
                                'max': [ 100 ]
                            },
                        start: [$scope.featureOpacity]
                    });
                    $("#" + div).on({
                        slide: function(){
                                ROADMAP.ol.setFeatureOpacity($("#" + div).val() / 100.0);
                                $scope.featureOpacity = $("#" + div).val()
                                $scope.$apply();
                            }
                    });
                },400);
            } else {

                //ROADMAP.ol.setMapOpacity(1);
                $scope.mapOpacity = ROADMAP.ol.getMapOpacity() * 100 || 100;
                setTimeout(function function_name (argument) {
                    $("." + div).noUiSlider({
                        range: {
                                'min': [  0 ],
                                'max': [ 100 ]
                        },
                        start: [$scope.featureOpacity]
                    });
                     $("#" + div).on({
                        slide: function(){
                                ROADMAP.ol.setMapOpacity($("#" + div).val() / 100.0);
                                $scope.mapOpacity = $("#" + div).val();
                                $scope.$apply();
                            }
                    });
                },400);
            }
        }

        //Feature Layer Slider
        createSlider("featureSlider", true);
        //Map Layer Slider
        //createSlider("mapSlider", false);

        $scope.togglePickLocation = function(){
            $scope.pickLocation = !$scope.pickLocation;
        }

        $scope.hidePickLocation = function(){
            $scope.pickLocation = false;
        }

        $scope.changeState = function() {
            angular.element(".locationStatus button span").removeClass('yellow-pulse');
            $scope.stateCounties = $scope.counties[this.activeState];
            //$scope.stateCounties = $scope.stateCounties.sort();
            $scope.$parent.activeCounty = undefined;
            $scope.$parent.activeState = this.activeState;
        }

        $scope.changeCounty = function() {

            $scope.hidePickLocation();
            //Zoom to county
            ROADMAP.location.highlight(this.activeCounty.fips, 'none', true);
            $scope.$parent.activeCounty = this.activeCounty;
        }

        $scope.togglePickProfile = function(){
            $scope.pickProfile = !$scope.pickProfile;
        }

        $scope.hidePickProfile = function(){
            $scope.pickProfile = false;
        }

        $scope.changeProfile = function() {
            //Do something when we change the profile
            $scope.$parent.activeProfile = this.activeProfile;
            //Hide Any Active Feature Layers if Profile is feature
            if ($scope.isFeatureProfile()) {
                ROADMAP.ol.hideFeatureLayers();
            }

            //When Changing Profile, make first map active
            $scope.changeMap(ROADMAP.service.getMaps(this.activeProfile, true)[0]);
            $scope.getScale();

            ROADMAP.profile.active(this.activeProfile);
        }

        $scope.changeMap = function(mapName) {

            $scope.$parent.activeMap = mapName;
            //console.log($scope.$parent.activeMap)
            //Get Layers
            var layers = ROADMAP.service.getLayers($scope.$parent.activeProfile, $scope.$parent.activeMap);

            //Add Map Layers
            if (Object.prototype.toString.call(layers) !== '[object Array]') {
                var layers = [layers];
            }
            //Grab layers that were added to the map
            var parent = $scope.$parent;
            $scope.active = ROADMAP.ol.addMapLayer(layers, function(loading) {
                parent.loadingMap = loading;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });

            if (!$scope.isFeatureProfile()) {
                ROADMAP.ol.showFeatureLayers();
                displayHazards();
            }

            createSlider("mapSlider", false);
        }

        $scope.setActiveToggle =  function(mapName){
            if(mapName == $scope.$parent.activeMap ) return true
        }

        $scope.getScale = function() {
            //get current scale and restrict legend items
            $scope.currentMapScale = ROADMAP.ol.getMap().getScale();
        }

        $scope.addMap = function() {

            var parent = $scope.$parent;
            parent.loadingCart = true;

            var mapMessage = $scope.$parent.service.getMaps($scope.$parent.activeProfile)[$scope.$parent.activeMap];
            var mapMessage = mapMessage.Message;
            $scope.$parent.cart = ROADMAP.cart.add($scope.$parent.activeProfile, $scope.$parent.activeMap,mapMessage, function() {
                parent.loadingCart = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
            //have mapfolio draw open to show user they are there. KF switched out pulse for flash on the map counter.
            /* if($scope.$parent.cart.length == 1){*/
            // angular.element(".drawerTopToggle").addClass('animated pulse'); commented out kf
            // angular.element(".drawerTopToggle").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', removeAnimationClass); commented out kf
            angular.element(".cart-count-empty").addClass('animated flash');
            angular.element(".cart-count-empty").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', removeAnimationClass);

            angular.element(".cart-count").addClass('animated flash');
            angular.element(".cart-count").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', removeAnimationClass);
            /*}*/
        }

        function removeAnimationClass() {
            // angular.element(".drawerTopToggle").removeClass('animated pulse'); commented out kf
            angular.element(".cart-count-empty").removeClass('animated flash');
            angular.element(".cart-count").removeClass('animated flash');
        }

        //Remove an item from the cart
        $scope.removeCartItem = function(idx) {
            $scope.$parent.cart = ROADMAP.cart.remove(idx);
        };

        $scope.setActiveProfile = function(profileName, mapName) {
            if ($.inArray(profileName, $scope.$parent.profiles) == -1) {
                return false;
            }
            $scope.activeProfile = $scope.$parent.activeProfile = profileName;

            //First map in profile || provided map name
            var mapName = (mapName) ? mapName : ROADMAP.service.getMaps($scope.activeProfile, true)[0];

            $scope.hidePickProfile();
            $scope.hideHazards();
            $scope.changeMap(mapName);
        }

        $scope.isFeatureProfile = function() {

            return ($scope.$parent.activeProfile == $scope.$parent.featureProfile);
        }

        $scope.hideHazards = function () {
            //set visibility false in other hazardObjects
            $.each($scope.$parent.hazards, function(name, hazard) {
                hazard.layers[0].visible = false;
                ROADMAP.ol.updateMapVisibilityOf(hazard.layers[0]);
            });
             $scope.noHazard = true;
             this.hazardObject = false;
        },

        $scope.toggleHazard = function() {
            //set visibility false in other hazardObjects
            $.each($scope.$parent.hazards, function(name, hazard) {
                hazard.layers[0].visible = false;
                ROADMAP.ol.updateMapVisibilityOf(hazard.layers[0]);
            });

            //set current visibility
            if (this.hazardObject) {
                this.hazardObject.layers[0].visible = true;
                var parent = $scope.$parent;
                ROADMAP.ol.addFeatureLayer(this.hazardObject.layers[0], function(loading) {
                    parent.loadingMap = loading;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });

            }

            //empty array while keeping the reference to orignal one intact
            $scope.activeFeature.length = 0;
            if (this.hazardObject) $scope.activeFeature.push(this.hazardObject.layers[0]);

            if (!this.hazardObject) {
                $scope.noHazard = true;
            } else {
                $scope.noHazard = false;
            }
        }

        //Show visible hazards
        function displayHazards() {
            //Turn on any visible hazards
            if ($scope.$parent.hazards) {
                $.each($scope.$parent.hazards, function(name, obj) {
                    $.each(obj.layers, function(idx, layer) {
                        if (layer.visible) {
                            ROADMAP.ol.addFeatureLayer(layer);
                        }
                    })
                })
            }
        }

        //Update any previous map/profile
        function previousView() {
            if ($scope.$parent.activeProfile) {
                $scope.setActiveProfile($scope.$parent.activeProfile, $scope.$parent.activeMap);
            }
        }

        //Load any county geometry first
        if ($scope.$parent.activeCounty) {
            ROADMAP.location.highlight($scope.$parent.activeCounty.fips, 'none', true, function() {
                if (!$scope.isFeatureProfile()) {
                    displayHazards();
                }
                previousView();
                $scope.$apply();
            });
        } else {
            if (!$scope.isFeatureProfile()) {
                displayHazards();
            }
            previousView();
        }
}).
controller('cartCtrl', function($scope) {
    //Check if images are expired on server
    var parent = $scope.$parent;
    ROADMAP.cart.expired(function(expired) {
        if (expired) {
            //Clear images and show loading
            parent.cart = ROADMAP.cart.clearImages();
            parent.loadingCart = true;
            //Apply if no digest in progress
            if (!$scope.$$phase) {
                $scope.$apply();
            }

            //updateimages
            ROADMAP.cart.refreshImages(function(cartItems) {
                parent.cart = cartItems;
                parent.loadingCart = false;

                //Apply if no digest in progress
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
        }
    });

    //Remove an item from the cart
    $scope.removeCartItem = function(idx) {
        $scope.$parent.cart = ROADMAP.cart.remove(idx);
    };

    $scope.printCart = function($event) {
        $event.preventDefault();
        ROADMAP.output.createImages(function() {
            //Only send what we need to create PDF
            var maps = {};
            $.each($scope.$parent.cart, function(idx, obj) {
                maps[obj.mapID + idx] = {}
                maps[obj.mapID + idx].fullImages = obj.fullImages;
                maps[obj.mapID + idx].mapID = $scope.$parent.keyToString(obj.mapID);
                maps[obj.mapID + idx].mapMessage = $scope.$parent.keyToString(obj.mapMessage);
                maps[obj.mapID + idx].profileID = $scope.$parent.keyToString(obj.profileID);
                maps[obj.mapID + idx].featureOpacity = obj.featureOpacity;
                maps[obj.mapID + idx].exposureOpacity = obj.exposureOpacity;
                maps[obj.mapID + idx].features = [];
                maps[obj.mapID + idx].shareUrl = obj.shareUrl;
                maps[obj.mapID + idx].shortShareUrl = obj.shortShareUrl;
                $.each(obj.features, function(featureidx, feature) {
                    maps[obj.mapID + idx].features.push(feature.LayerName);
                });
                maps[obj.mapID + idx].legend = obj.legend;

            });


            //Open HTML Popup window for the report
            //var reportWindow = window.open('report/', 'CoastalFloodExposure', 'width=750,height=850,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes');
            $scope.mapCart = maps;
            var reportWindow =  window.open('report/','_blank');
            if (window.focus){
                reportWindow.focus();
            }
        })
    }
}).
controller('shareCtrl', function($scope, $routeParams) {

    var bbox = new OpenLayers.Bounds($routeParams.extent.split(","))
    //Activate Map
    ROADMAP.ol.createMap('shareMap',{extents:bbox, basemap:$routeParams.basemap });
    ROADMAP.ol.resetMapLayers();

    var mymap = ROADMAP.ol.getMap();
    $scope.currentMapScaleShare = mymap.getScale();


    addMapLayers();

    function addMapLayers() {
        //Get Layers
        var layers = ROADMAP.service.getLayers($routeParams.profileName, $routeParams.mapName);


        //For Header Title
        $scope.mapID = $routeParams.mapName;
        $scope.profileID = $routeParams.profileName;


        //Add Map Layers
        if (Object.prototype.toString.call(layers) !== '[object Array]') {
            var layers = [layers];
        }

        //Grab layers that were added to the map
        $scope.active = ROADMAP.ol.addMapLayer(layers, function(loading) {
            $scope.loadingShareMap = loading;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

        layers.forEach(function (l) {
            l.mapLayer.setOpacity($routeParams.exposureOpacity || 1); // change to exposure opacity
        });

        var featureLayers = $routeParams.features;
        if (!featureLayers) {
            featureLayers = [];
        } else {
            featureLayers = featureLayers.split(",");
        }

        //Add any feature layers
        if ($scope.$parent.activeProfile !== $scope.$parent.featureProfile) {
            //Turn on any visible hazards

            if ($scope.$parent.hazards) {
                $.each($scope.$parent.hazards, function(name, obj) {
                    $.each(obj.layers, function(idx, layer) {
                        if ($.inArray(layer.ShareId, featureLayers) !== -1) {
                            layer.visible = true;
                            ROADMAP.ol.addFeatureLayer(layer);
                            layer.mapLayer.setOpacity($routeParams.hazardOpacity || 1);
                            $scope.active.push(layer)
                        }
                    });
                })
            }
        }
    }

    //Add Item
    //console.log($routeParams);
}).
controller('servicesCtrl', function($scope, services, $rootScope, $location, $anchorScroll, $routeParams) {
    services.then(function(response) {
            $scope.profiles = response.data.profiles;
            $scope.profiles.forEach(function (profile) {
                profile.layers.forEach(function (layer) {
                    layer.mapService = layer.sources.shift();
                    layer.authoritativeSources = layer.sources;
                })
            });
    });
}).
controller('resourcesCtrl', function($scope, resources) {
    resources.then(function(response) {
        if (response.status === 200) {
            $scope.resources = response.data.profiles;
        }
    })
}).
controller('casesCtrl', function($scope, cases) {
    cases.then(function(response) {
        if (response.status === 200) {
            $scope.cases = response.data;
        }
    })
});